import { RoutesStateType } from './RoutesInitialState.types'

export const RoutesInitialState: RoutesStateType = {
  redirectTo: '',
  redirecting: false
}
